import { VectorCluster } from "./api";

export const transformVectorClusterName = ({
  ID,
  description,
}: VectorCluster) =>
  description && description !== "" ? `${ID}: ${description}` : ID;
